export const CHANNEL_RECONNECTING = "channel reconnecting";
export const CHANNEL_INITIALIZED = "channel initialized";
export const CHANNEL_UNINITIALIZED = "channel uninitialized";
export const CONNECTION_CHANGED = "connection change";
